import React, { useContext, useEffect } from "react";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import NewSignIn from "./components/Auth/AdminSignIn/SignIn";
import ConfigSignIn from "./components/Auth/Config/ConfigSignIn/ConfigSignIn";
import SignIn from "./components/Auth/SignIn/SignIn";
import Main from "./components/Layout/Main/Main";
import AddMachine from "./components/Main/AddMachine/AddMachine";
import AddCliente from "./components/Main/Cliente/AddCliente/AddCliente";
import AddMaquina from "./components/Main/Cliente/AddMaquina/AddMaquina";
import AdminDeleteALLPagamentos from "./components/Main/Cliente/AdminSearchPagamentos/AdminDeleteALLPagamentos";
import AdminDeletePagamento from "./components/Main/Cliente/AdminSearchPagamentos/AdminDeletePagamento";
import AdminEditPagamento from "./components/Main/Cliente/AdminSearchPagamentos/AdminEditPagamento";
import ClienteMaquinas from "./components/Main/Cliente/ClienteMaquinas/ClienteMaquinas";
import ClientesDashboard from "./components/Main/Cliente/ClientesDashboard/ClientesDashboard";
import CreditoRemoto from "./components/Main/Cliente/CreditoRemoto/CreditoRemoto";
import DeleteCliente from "./components/Main/Cliente/DeleteCliente/DeleteCliente";
import EditCliente from "./components/Main/Cliente/EditCliente/EditCliente";
import ListaMaquinas from "./components/Main/Cliente/ListaMaquinas/ListaMaquinas";
import MaqPagamentosAdm from "./components/Main/Cliente/MaqPagamentos/Adm/MaqPagamentosAdm";
import MaqPagamentosCliente from "./components/Main/Cliente/MaqPagamentos/Cliente/MaqPagamentosCliente";
import MensalidadesAdm from "./components/Main/Cliente/Mensalidades/Adm/MensalidadesAdm";
import MensalidadesAdmList from "./components/Main/Cliente/Mensalidades/Adm/MensalidadesAdmList";
import MensalidadesCliente from "./components/Main/Cliente/Mensalidades/Cliente/MensalidadesCliente";
import PagamentosCliente from "./components/Main/Cliente/PagamentosCliente/PagamentosCliente";
import RelatorioAdmin from "./components/Main/Cliente/RelatorioAdmin/RelatorioAdmin";
import RelatorioDisp from "./components/Main/Cliente/RelatorioDisp/RelatorioDisp";
import RelatorioDispAdmin from "./components/Main/Cliente/RelatorioDispAdmin/RelatorioDispAdmin";
import ResetSenha from "./components/Main/Cliente/ResetSenha/ResetSenha";
import Trocar from "./components/Main/Cliente/Trocar/Trocar";
import DashboardMaquinas from "./components/Main/Dashboard/DashboardMáquinas";
import HelpPage from "./components/Main/HelpPage/HelpPage";
import Relatorio from "./components/Main/Relatorio/Relatorio/Relatorio";
import RemoteCredit from "./components/Main/RemoteCredit/RemoteCredit";
import DeleteMaquina from "./components/Main/SearchPagamentos/DeleteMaquina";
import DeletePagamento from "./components/Main/SearchPagamentos/DeletePagamento";
import EditPagamento from "./components/Main/SearchPagamentos/EditPagamento";
import TokenHelpPage from "./components/Main/TokenHelpPage/TokenHelpPage";
import NotFound from "./components/NotFound/NotFound";
import { AuthContext } from "./contexts/AuthContext";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import * as links from "./utils/links";

function App() {
  const {
    setDataUser,
    loading,
    notiMessage,
    setNotiMessage,
    notiMessageInfo,
    setNotiMessageInfo,
    authInfo,
  } = useContext(AuthContext);

  const type = authInfo?.dataUser?.type;

  useEffect(() => {
    if (notiMessage) {
      setNotiMessage(null);

      switch (notiMessage.type) {
        case "error":
          NotificationManager.error(notiMessage.message, "Hmm... ");
          break;
        case "success":
          NotificationManager.success(notiMessage.message, "... ");
          break;
        case "info":
          NotificationManager.info(notiMessage.message, "... ");
          break;
        case "warning":
          NotificationManager.warning(notiMessage.message, "... ");
          break;
      }
    }
  }, [notiMessage]);

  // useEffect(() => {
  //     if (notiMessageInfo) {
  //         setNotiMessageInfo(null)
  //         NotificationManager.info(notiMessageInfo, '... ');
  //     }
  // }, [notiMessageInfo])

  return (
    <>
      <NotificationContainer />
      <Routes>
        {
          <>
            <Route
              path={`${links.FORNECEDOR_SEARCH_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    {/* <PagamentosSearch /> */}
                    <MaqPagamentosCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    {/* <AdminPagamentosSearch /> */}
                    <MaqPagamentosAdm />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_MENSALIDADES_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesAdm />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_MENSALIDADES}`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.MENSALIDADES_ADM_LIST}`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesAdmList />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_PAGAMENTOS}`}
              element={
                <PrivateRoute>
                  <Main>
                    <PagamentosCliente />
                    {/* <Dashboard/> */}
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CREDITO_REMOTO_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <CreditoRemoto />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDIT_FORNECEDOR_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditPagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_EDIT_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminEditPagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_TROCAR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <Trocar />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.ADD_CLIENTES_MAQUINA_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AddMaquina />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDITAR_CLIENTES}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_FORNECEDOR_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeletePagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_DELETE_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminDeletePagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINA_DELETE_PAGAMENTOS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminDeleteALLPagamentos />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_CLIENTE}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeleteCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <Relatorio />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_DISP_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioDispAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_DISP}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioDisp />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <ClienteMaquinas />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeleteMaquina />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.HELP_PAGE}`}
              element={
                <PrivateRoute>
                  <Main>
                    <HelpPage />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.TOKEN_HELP_PAGE}`}
              element={
                <PrivateRoute>
                  <Main>
                    <TokenHelpPage />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_FORNECEDOR}
              element={
                <PrivateRoute>
                  <Main>
                    <DashboardMaquinas></DashboardMaquinas>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_CLIENTES}
              element={
                <PrivateRoute>
                  <Main>
                    <ClientesDashboard />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.LISTA_MAQUINAS}
              element={
                <PrivateRoute>
                  <Main>
                    <ListaMaquinas />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.NEW_PASSWORD}
              element={
                <PrivateRoute>
                  <Main>
                    <ResetSenha />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ADD_MACHINE}
              element={
                <PrivateRoute>
                  <Main>
                    <AddMachine />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ADD_CLIENTES}
              element={
                <PrivateRoute>
                  <Main>
                    <AddCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.REMOTE_CREDIT}
              element={
                <PrivateRoute>
                  <Main>
                    <RemoteCredit />
                  </Main>
                </PrivateRoute>
              }
            />
          </>
        }
        <Route
          path={links.SIGNIN}
          element={
            <PublicRoute>
              <SignIn />
            </PublicRoute>
          }
        />
        <Route
          path={links.ADMIN_SIGNIN}
          element={
            <PublicRoute>
              <NewSignIn />
            </PublicRoute>
          }
        />
        <Route
          path={links.CONFIG}
          element={
            <PublicRoute>
              <ConfigSignIn />
            </PublicRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
